<template>
  <div v-loading="loading" class="main">
    <div class="tab_content">
      <div
        class="tab_content_each"
        v-for="(item, index) in options"
        :key="index"
        @click="selectType(item)"
        :class="{ active: item.value == listQuery.method }"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-if="listQuery.method == 'tax'">
      <div class="tab_content_btn">
        <div>税款确认</div>
        <div v-if="comInfo.automatic === 1">
          {{ $filterAutoStatusText(taxInfo.confirmStatus, "qr") }}
        </div>
        <div v-else>
          <span>国：{{ $homeTaxStatus(taxInfo.confirmStatusGuoShui) }}</span>
          <span style="margin-left: 6px"
            >个：{{ $homeTaxStatus(taxInfo.confirmStatusGeShui) }}</span
          >
        </div>
      </div>
      <div class="each_main">
        <div class="record">增值税</div>
        <div class="fw_date">增值税：{{ $comdify(taxInfo.zzsAmount) }}</div>
        <div class="fw_date">
          城市维护建设税：{{ $comdify(taxInfo.cswhjssAmount) }}
        </div>
        <div class="fw_date">教育费附加：{{ $comdify(taxInfo.jyffj) }}</div>
        <div class="fw_date">地方教育附加：{{ $comdify(taxInfo.dfjyffj) }}</div>
      </div>
      <div class="each_main">
        <div class="record">企业所得税</div>
        <div class="fw_date">营业收入：{{ $comdify(taxInfo.yysr) }}</div>
        <div class="fw_date">营业成本：{{ $comdify(taxInfo.yycb) }}</div>
        <div class="fw_date">利润总额：{{ $comdify(taxInfo.lrze) }}</div>
        <div class="fw_date">应补退税额：{{ $comdify(taxInfo.ybtse) }}</div>
      </div>
      <div v-if="taxInfo.remainTax && taxInfo.remainTax.length > 0">
        <div class="each_main" v-for="item in taxInfo.remainTax" :key="item.id">
          <div class="record">{{ $tableNameFilter(item.tableName) }}</div>
          <div class="fw_date">应补退税额：{{ $comdify(item.tax) }}</div>
        </div>
      </div>
      <div class="each_main">
        <div class="record">个税</div>
        <div class="fw_date">工资总额：{{ $comdify(taxInfo.salary) }}</div>
        <div class="fw_date">应补退税额：{{ $comdify(taxInfo.gsTotal) }}</div>
      </div>
      <div class="send_btn">
        <div @click="sendCat('tax')">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="confirmTax(comInfo.automatic === 1 ? 9 : 6)">
          <el-icon> <Checked /> </el-icon>申报暂不扣款
        </div>

        <div @click="confirmTax(comInfo.automatic === 1 ? 3 : 1)">
          <el-icon> <Checked /> </el-icon>申报并扣款
        </div>
      </div>
      <div class="tab_content_btn">
        <div>社保确认</div>
        <div>
          {{ $filterAutoStatusText(taxInfo.status, "qr") }}
        </div>
      </div>
      <div class="each_main">
        <div class="record">社保</div>
        <div class="fw_date">人数：{{ taxInfo.personCount || 0 }}</div>
        <div class="fw_date">
          金额：{{
            $comdify(
              parseFloat((taxInfo?.grAmount || 0) + (taxInfo?.dwAmount || 0)),
            )
          }}
        </div>
      </div>
      <div class="send_btn">
        <div @click="sendCat('shebao')">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="confirmShebao(9)">
          <el-icon> <Checked /> </el-icon>申报暂不扣款
        </div>
        <div @click="confirmShebao(3)">
          <el-icon> <Checked /> </el-icon>申报并扣款
        </div>
      </div>
    </div>
    <div v-if="listQuery.method == 'emi'">
      <div
        class="tab_content_btn"
        style="text-align: left"
        v-if="!taxEstimeInfo.updatedAt?.match('0001-01-01')"
      >
        预估时间：{{
          taxEstimeInfo.updatedAt
            ? $parseTime(taxEstimeInfo.updatedAt, "{y}-{m}-{d}")
            : ""
        }}
      </div>
      <div>
        <div class="each_main">
          <div class="tab-container">
            <div class="tabs">
              <div
                v-for="tab in ygOptions"
                :key="tab.value"
                :class="['tab', { active: activeTab === tab.value }]"
                @click="selectTab(tab)"
              >
                {{ tab.label }}
              </div>
            </div>
          </div>
          <!--     增值税税款预估     -->
          <div v-if="activeTab === '1'">
            <!--     一般纳税人     -->
            <div v-if="comForm.type == '2'">
              <div class="record">税款预估</div>
              <div class="fw_date">
                本月开具专票：{{ matchData.outSpecialNum }}份&nbsp;|&nbsp;{{
                  $comdify(matchData.outSpecialSumAmount)
                }}元&nbsp;|&nbsp;{{ $comdify(matchData.outSpecialTaxAmount) }}元
              </div>
              <div class="fw_date">
                本月开具普票：{{ matchData.outGeneralNum }}份&nbsp;|&nbsp;{{
                  $comdify(matchData.outGeneralSumAmount)
                }}元&nbsp;|&nbsp;{{ $comdify(matchData.outGeneralTaxAmount) }}元
              </div>
              <div class="fw_date">
                本月取得专票：{{ matchData.inSpecialNum }}份&nbsp;|&nbsp;{{
                  $comdify(matchData.inSpecialSumAmount)
                }}元&nbsp;|&nbsp;{{ $comdify(matchData.inSpecialTaxAmount) }}元
              </div>
              <div class="fw_date">
                本月取得普票：{{ matchData.inGeneralNum }}份&nbsp;|&nbsp;{{
                  $comdify(matchData.inGeneralSumAmount)
                }}元&nbsp;|&nbsp;{{ $comdify(matchData.inGeneralTaxAmount) }}元
              </div>
              <div class="fw_date">
                上期留抵：{{ $comdify(taxEstimeInfo.pre_stay_pay) }}
              </div>
              <div v-if="taxEstimeInfo.countGx">
                <div class="fw_date">
                  预勾选增值税：{{
                    $comdify(taxEstimeInfo.estimate_value_added_tax_gx)
                  }}
                </div>
                <div class="fw_date">
                  预勾选附加税：{{
                    $comdify(taxEstimeInfo.estimate_additional_tax_gx)
                  }}
                </div>
                <div class="fw_date">
                  合计税款：{{
                    $comdify(
                      (Number(taxEstimeInfo.estimate_additional_tax_gx)
                        ? Number(taxEstimeInfo.estimate_additional_tax_gx)
                        : 0) +
                        (Number(taxEstimeInfo.estimate_value_added_tax_gx)
                          ? Number(taxEstimeInfo.estimate_value_added_tax_gx)
                          : 0),
                    )
                  }}
                </div>
              </div>
              <div v-else>
                <div class="fw_date">
                  预估增值税：{{
                    $comdify(taxEstimeInfo.estimate_value_added_tax)
                  }}（税负：{{
                    taxEstimeInfo.out_amount === "0.00" ||
                    !taxEstimeInfo.out_amount
                      ? "0.00"
                      : $comdify(
                          (Number(
                            taxEstimeInfo.estimate_value_added_tax
                              ? taxEstimeInfo.estimate_value_added_tax
                              : 0,
                          ) /
                            Number(taxEstimeInfo.out_amount)) *
                            100,
                        )
                  }}%）
                </div>
                <div class="fw_date">
                  预估附加税：{{
                    $comdify(taxEstimeInfo.estimate_additional_tax)
                  }}
                </div>
                <div class="fw_date">
                  合计税款：{{
                    $comdify(
                      (Number(taxEstimeInfo.estimate_additional_tax)
                        ? Number(taxEstimeInfo.estimate_additional_tax)
                        : 0) +
                        (Number(taxEstimeInfo.estimate_value_added_tax)
                          ? Number(taxEstimeInfo.estimate_value_added_tax)
                          : 0),
                    )
                  }}
                </div>
              </div>
            </div>
            <!--     小规模     -->
            <div v-if="comForm.type == '1'">
              <div class="record">税款预估</div>
              <div class="fw_date">
                {{ matchData.isJd ? "本季度" : "本月" }}开票情况：{{
                  matchData.outGeneralNum + matchData.outSpecialNum
                }}份&nbsp;|&nbsp;{{
                  $comdify(
                    matchData.outGeneralSumAmount +
                      matchData.outSpecialSumAmount,
                  )
                }}元&nbsp;|&nbsp;{{
                  $comdify(
                    matchData.outGeneralTaxAmount +
                      matchData.outSpecialTaxAmount,
                  )
                }}元
              </div>
              <div class="fw_date">
                开具销项专票：{{ matchData.outSpecialNum }}份&nbsp;|&nbsp;{{
                  $comdify(matchData.outSpecialSumAmount)
                }}元&nbsp;|&nbsp;{{ $comdify(matchData.outSpecialTaxAmount) }}元
              </div>
              <div class="fw_date">
                预估增值税：{{
                  $comdify(taxEstimeInfo.estimate_value_added_tax)
                }}（税负：{{
                  taxEstimeInfo.out_amount === "0.00" ||
                  !taxEstimeInfo.out_amount
                    ? "0.00"
                    : $comdify(
                        (Number(
                          taxEstimeInfo.estimate_value_added_tax
                            ? taxEstimeInfo.estimate_value_added_tax
                            : 0,
                        ) /
                          Number(taxEstimeInfo.out_amount)) *
                          100,
                      )
                }}%）
              </div>
              <div class="fw_date">
                预估附加税：{{
                  $comdify(taxEstimeInfo.estimate_additional_tax)
                }}
              </div>
              <div class="fw_date">
                合计税款：{{
                  $comdify(
                    (Number(taxEstimeInfo.estimate_additional_tax)
                      ? Number(taxEstimeInfo.estimate_additional_tax)
                      : 0) +
                      (Number(taxEstimeInfo.estimate_value_added_tax)
                        ? Number(taxEstimeInfo.estimate_value_added_tax)
                        : 0),
                  )
                }}
              </div>
              <div class="fw_date">
                小规模季度累计开票：{{
                  $comdify(taxEstimeInfo.out_invoice_in_amount_jd)
                }}
              </div>
              <div class="fw_date">
                小规模连续12月累计开票：{{
                  $comdify(taxEstimeInfo.out_invoice_in_amount_12)
                }}
              </div>
            </div>
          </div>
          <!--     企业所得税预估     -->
          <div v-else>
            <div class="record">税款预估</div>
            <div class="fw_date">
              本年累计营业收入：{{ matchData.revenueStr }}元
            </div>
            <div class="fw_date">
              本年累计营业成本：{{ matchData.costStr }}元
            </div>
            <div class="fw_date">
              本年累计期间费用：{{ matchData.expensesStr }}元
            </div>
            <div class="fw_date">
              本期可抵用进项发票：{{
                matchData.inInvoiceCount
              }}份&nbsp;|&nbsp;{{
                matchData.inInvoiceAmountStr
              }}元&nbsp;|&nbsp;{{ matchData.inInvoiceTaxStr }}元
            </div>
            <div class="fw_date">
              本年累计利润总额：{{ matchData.totalProfitStr }}元
            </div>
            <div class="fw_date">
              本年预估应缴税款：{{ matchData.taxAmountStr }}元
            </div>
          </div>
        </div>
      </div>
      <div class="each_main">
        <div class="record">预估发票明细</div>
        <div
          class="flex_between excel_style fw_date"
          @click="taxEstimationDown()"
        >
          <div class="flex_align_center">
            <i class="iconfont icon-wenjianleixing-biaozhuntu-gongzuobiao"></i>
            {{ comInfo.name }}
          </div>
          <div>
            <el-icon class="download_icon">
              <Download />
            </el-icon>
          </div>
        </div>
      </div>
      <div class="send_btn">
        <div @click="sendCat('emi')">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="taxEstimationDown(1)">推送发票明细</div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" title="税款确认" width="80%" top="200px">
      <el-checkbox-group v-model="confirmType">
        <el-checkbox label="tax">国税</el-checkbox>
        <el-checkbox label="tax_gs">个税</el-checkbox>
      </el-checkbox-group>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small"
            >取消</el-button
          >
          <el-button type="primary" @click="baseConfirm" size="small"
            >确定</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from "vue"
import {
  taxConfirmInfo,
  taxConfirm,
  sbConfirm,
  taxEstimationInfo,
  taxEstimationExport,
  copyTaxEstimate,
  shebaoDetail,
  baseTaxConfirm,
  copyTaxQyEstimate,
} from "@/api/tax"
import { ElMessage, dayjs } from "element-plus"
const { proxy } = getCurrentInstance()
const props = defineProps({
  period: { type: String, default: "" },
  comInfo: { type: Object, default: () => {} },
  cKey: { type: Number, default: 0 },
})
const listQuery = ref({
  method: "tax",
  comId: null,
  period: null,
})
const comForm = ref({})
const loading = ref(false)
const options = ref([
  { label: "税款确认", value: "tax" },
  { label: "税款预估", value: "emi" },
])
const ygOptions = ref([
  { label: "增值税税款预估", value: "1" },
  { label: "企业所得税预估", value: "2" },
])
const activeTab = ref("1")

const taxInfo = ref({})
const taxEstimeInfo = ref({})
const matchData = ref({})
const dialogVisible = ref(false)
const confirmType = ref(["tax", "tax_gs"])
const confirmStatus = ref("")

const getList = () => {
  loading.value = true
  if (listQuery.value.method == "tax") {
    taxConfirmInfo(listQuery.value).then((res) => {
      loading.value = false
      if (res.data.msg == "success") {
        taxInfo.value = res.data.data.info
      }
    })
  } else {
    // 企业所得税预估
    if (activeTab.value === "2") {
      let param = {
        coms: [{ id: listQuery.value.comId, type: comForm.value.type }],
        period: listQuery.value.period,
      }
      copyTaxQyEstimate(param).then((res) => {
        loading.value = false
        if (res.data.msg == "success") {
          matchData.value = res.data.data[0]
        }
      })
    } else {
      taxEstimationInfo(listQuery.value).then((res) => {
        loading.value = false
        if (res.data.msg == "success") {
          taxEstimeInfo.value = res.data.data.info
        }
      })
      let param = {
        coms: [{ id: listQuery.value.comId, type: comForm.value.type }],
        period: listQuery.value.period,
      }
      copyTaxEstimate(param).then((res) => {
        if (res.data.msg == "success") {
          matchData.value = res.data.data[0]
        }
      })
    }
  }
}

const selectType = (item) => {
  listQuery.value.method = item.value
  activeTab.value = "1"
  getList()
}
// 税款预估的下的tabbar切换
const selectTab = (item) => {
  activeTab.value = item.value
  getList()
}

watch(
  () => [props.period, props.comInfo, props.cKey],
  (newVal) => {
    listQuery.value.period = newVal[0]
    listQuery.value.comId = newVal[1].id
    comForm.value = newVal[1]
    if (listQuery.value.comId) {
      getList()
    }
  },
  { immediate: true },
)

const confirmTax = (status) => {
  if (props.comInfo.automatic === 1 && taxInfo.value.confirmStatus != 2) {
    ElMessage.warning("税款不是待确认状态不可确认")
    return
  }
  let str = ""
  if (props.comInfo.automatic === 1) {
    str = status == 3 ? "申报并扣款" : "申报暂不扣款"
  } else {
    str = status == 1 ? "申报并扣款" : "申报暂不扣款"
  }
  proxy
    .$confirm(`确定${str}吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(() => {
      confirmStatus.value = status
      if (props.comInfo.automatic !== 1) {
        confirmType.value = ["tax", "tax_gs"]
        dialogVisible.value = true
      } else {
        automaticConfirm(status)
      }
    })
}

// ai财务工厂的确认
const automaticConfirm = (status) => {
  const param = {
    comId: listQuery.value.comId,
    period: listQuery.value.period,
    status: status,
  }
  taxConfirm(param).then((res) => {
    if (res.data.msg == "success") {
      ElMessage.success("确认成功")
      getList()
    }
  })
}
// 基础版的确认
const baseConfirm = () => {
  let param = {
    comId: listQuery.value.comId,
    period: listQuery.value.period,
    status: confirmStatus.value,
    types: confirmType.value,
  }
  baseTaxConfirm(param).then((res) => {
    if (res.data.msg == "success") {
      dialogVisible.value = false
      ElMessage.success("确认成功")
      getList()
    }
  })
}

const confirmShebao = (status) => {
  if (props.comInfo.automatic === 1 && taxInfo.value.status != 2) {
    ElMessage.warning("社保不是待确认状态不可确认")
    return
  }
  let str = status == 3 ? "申报并扣款" : "申报暂不扣款"
  proxy
    .$confirm(`确定${str}吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(() => {
      let param = {
        comId: listQuery.value.comId,
        period: listQuery.value.period,
        status: status,
      }
      sbConfirm(param).then((res) => {
        if (res.data.msg == "success") {
          ElMessage.success("确认成功")
          getList()
        }
      })
    })
}
const taxEstimationDown = (flag) => {
  let param = {
    comId: listQuery.value.comId,
    period: listQuery.value.period,
    needPush: flag ? true : false,
    type: activeTab.value,
  }
  taxEstimationExport(param).then((res) => {
    if (res.data.msg == "success") {
      if (flag) {
        wx.invoke(
          "sendChatMessage",
          {
            msgtype: "file", //消息类型，必填
            file: {
              mediaid: res.data.data.mediaId, //文件的素材id
            },
          },
          function (res) {
            if (res.err_msg == "sendChatMessage:ok") {
              ElMessage.success("发送成功")
            }
          },
        )
      } else {
        window.open(res.data.data.path)
      }
    }
  })
}
const sendCat = (flag) => {
  console.log(sendText(flag))
  wx.invoke(
    "sendChatMessage",
    {
      msgtype: "text", //消息类型，必填
      enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
      text: {
        content: sendText(flag),
      },
    },
    function (res) {
      if (res.err_msg == "sendChatMessage:ok" && flag !== "shebao") {
        ElMessage.success("发送成功")
      }
    },
  )
  if (flag == "shebao") {
    const params = {
      comIds: [listQuery.value.comId],
      period: listQuery.value.period,
      automatic: listQuery.value.automatic === 1,
      from: 2,
    }
    shebaoDetail(params).then((res) => {
      if (res.data.msg == "success") {
        if (
          res.data.data?.mediaIdMap &&
          res.data.data?.mediaIdMap[listQuery.value.comId]
        ) {
          const mediaid = res.data.data?.mediaIdMap[listQuery.value.comId]
          console.log(mediaid)
          wx.invoke("sendChatMessage", {
            msgtype: "file", //消息类型，必填
            file: {
              mediaid, //文件的素材id
            },
          })
        }
        ElMessage.success("发送成功")
      }
    })
  }
}

const sendText = (method) => {
  let content = `您的企业「${props.comInfo.name}」，${props.period.substring(
    0,
    4,
  )}年${props.period.substring(4, 6)}账期`
  let shebaoContent = `【社医保对账单】\n`
  // 企业所得税预估
  if (activeTab.value == "2") {
    content = `老板您好，您的企业「${
      props.comInfo.name
    }」截止${props.period.substring(0, 4)}年${props.period.substring(
      4,
      6,
    )}账期\n`
  }
  let amount = 0
  let fjsAmount =
    taxInfo.value.cswhjssAmount * 1 +
    taxInfo.value.jyffj * 1 +
    taxInfo.value.dfjyffj * 1
  let totalAmount =
    fjsAmount +
    parseFloat(taxInfo.value.zzsAmount || 0) +
    parseFloat(taxInfo.value.ybtse || 0) +
    parseFloat(taxInfo.value.gsTotal || 0)
  let shebaoDate = props.period
  if (taxInfo.value.lastPeriod) {
    shebaoDate = taxInfo.value.lastPeriod.replace(/-/g, "")
  }
  const year = shebaoDate.slice(0, 4)
  const month = shebaoDate.slice(4, 6)
  switch (method) {
    case "tax":
      content += `税款如下：\n`
      content += `增值税：${proxy.$comdify(taxInfo.value.zzsAmount)}\n`
      content += `增值税附加税：${proxy.$comdify(fjsAmount)}\n`
      content += `其中：城市维护建设税：${proxy.$comdify(
        taxInfo.value.cswhjssAmount,
      )}\n`
      content += `      教育费附加：${proxy.$comdify(taxInfo.value.jyffj)}\n`
      content += `      地方教育费附加：${proxy.$comdify(
        taxInfo.value.dfjyffj,
      )}\n`
      content += `企业所得税：${proxy.$comdify(taxInfo.value.ybtse)}\n`
      if (taxInfo.value.remainTax && taxInfo.value.remainTax.length > 0) {
        taxInfo.value.remainTax.map((item) => {
          content += `${proxy.$tableNameFilter(
            item.tableName,
          )}：${proxy.$comdify(item.tax)}\n`
          // 缓存三个附加税数值
          const csjsVal = Number(item.fjsDetail.csjs || 0)
          const jyfjVal = Number(item.fjsDetail.jyfj || 0)
          const dfjyVal = Number(item.fjsDetail.dfjy || 0)
          // 附加税合计
          const addTotal = csjsVal + jyfjVal + dfjyVal
          if (item.tableName == "gs_xfs" && addTotal > 0) {
            content += `消费税附加税：${proxy.$comdify(addTotal)}\n`
            content += `其中：城市维护建设税：${proxy.$comdify(
              item.fjsDetail.csjs,
            )}\n`
            content += `      教育费附加：${proxy.$comdify(
              item.fjsDetail.jyfj,
            )}\n`
            content += `      地方教育费附加：${proxy.$comdify(
              item.fjsDetail.dfjy,
            )}\n`
          }
          amount += parseFloat(item.tax || 0)
        })
      }
      totalAmount = (totalAmount + amount).toFixed(2) * 1
      content += `个税：${proxy.$comdify(taxInfo.value.gsTotal)}\n`
      content += `总计：${proxy.$comdify(totalAmount)}\n`
      content += `${props.period.substring(0, 4)}年${props.period.substring(
        4,
        6,
      )}账期税款如上，请确认是否有变动，如有疑问请随时沟通`
      content += `\n另本账期缴款日期截至${taxInfo.value.endDay}号申报结束,如逾期未缴款,税局会生成滞纳金,望注意。`
      break
    case "shebao":
      shebaoContent += `公司名称：${props.comInfo.name}\n`
      shebaoContent += `【本月社保】\n缴费月份：${year}年${month}月\n`
      shebaoContent += `缴费人次：${taxInfo.value.currentPeopleCount}人次\n`
      shebaoContent += `缴费总金额：${proxy.$comdify(
        taxInfo.value.currentAmount,
      )}元\n`
      shebaoContent += `其中：单位承担：${proxy.$comdify(
        taxInfo?.value.currentAmountDw,
      )}元\n`
      shebaoContent += `\t  个人承担：${proxy.$comdify(
        taxInfo?.value.currentAmountGr,
      )}元\n`
      if (taxInfo?.value.preMonth && taxInfo?.value.preMonth !== "月-月") {
        shebaoContent += `【补缴社保】\n补缴月份：${taxInfo.value.preMonth}\n`
        shebaoContent += `补缴累计金额：${proxy.$comdify(
          taxInfo.value.preAmount,
        )}元\n`
        shebaoContent += `其中：单位承担：${proxy.$comdify(
          taxInfo?.value.preAmountDw,
        )}元\n`
        shebaoContent += `\t  个人承担：${proxy.$comdify(
          taxInfo?.value.preAmountGr,
        )}元\n`
      }
      shebaoContent += "(以上信息请收悉，并确保银行账户有足够余额扣款)"
      break
    case "emi":
      if (activeTab.value == "1") {
        content += `税款预估为`
        if (props.comInfo.type == "2") {
          // 一般纳税人的提示
          if (matchData.value?.countGx) {
            content += `【${proxy.$comdify(
              (Number(taxEstimeInfo.value.estimate_additional_tax_gx)
                ? Number(taxEstimeInfo.value.estimate_additional_tax_gx)
                : 0) +
                (Number(taxEstimeInfo.value.estimate_value_added_tax_gx)
                  ? Number(taxEstimeInfo.value.estimate_value_added_tax_gx)
                  : 0),
            )}】元，`
          } else {
            content += `【${proxy.$comdify(
              (Number(taxEstimeInfo.value.estimate_additional_tax)
                ? Number(taxEstimeInfo.value.estimate_additional_tax)
                : 0) +
                (Number(taxEstimeInfo.value.estimate_value_added_tax)
                  ? Number(taxEstimeInfo.value.estimate_value_added_tax)
                  : 0),
            )}】元，`
          }
          content += "具体如下：\n"
          content += "\n【本月开具发票】"
          content += `\n\t销项专票：${
            matchData.value.outSpecialNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.outSpecialSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.outSpecialTaxAmount) || "0.00"
          }元`
          content += `\n\t销项普票：${
            matchData.value.outGeneralNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.outGeneralSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.outGeneralTaxAmount) || "0.00"
          }元\n`
          content += "\n【本月取得发票】"
          content += `\n\t进项专票：${
            matchData.value.inSpecialNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.inSpecialSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.inSpecialTaxAmount) || "0.00"
          }元`
          content += `\n\t进项普票：${
            matchData.value.inGeneralNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.inGeneralSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.inGeneralTaxAmount) || "0.00"
          }元\n`

          content += `\n上期留抵：${proxy.$comdify(
            taxEstimeInfo.value.pre_stay_pay,
          )}元`
          content += `\n本期进项转出：${
            proxy.$comdify(matchData.value.voidInInvoiceSum) || "0.00"
          }元`
          content += `\n剩余未勾选本期进项：${
            matchData.value.notGxInInvoiceCount
          }份|价税合计：${
            proxy.$comdify(matchData.value.notGxInInvoiceSum) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.notGxInInvoiceTax) || "0.00"
          }元`
          content += `\n剩余未勾选往期进项：${
            matchData.value.notGxInInvoiceCountWq
          }份|价税合计：${
            proxy.$comdify(matchData.value.notGxInInvoiceSumWq) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.notGxInInvoiceTaxWq) || "0.00"
          }元\n`
        } else {
          // 小规模的提示
          content += `【${proxy.$comdify(
            (Number(taxEstimeInfo.value.estimate_additional_tax)
              ? Number(taxEstimeInfo.value.estimate_additional_tax)
              : 0) +
              (Number(taxEstimeInfo.value.estimate_value_added_tax)
                ? Number(taxEstimeInfo.value.estimate_value_added_tax)
                : 0),
          )}】元，`
          content += "具体如下：\n"
          content += `\n【本${matchData.value.isJd ? "季度" : "月"}开具发票】`
          content += `\n\t销项专票：${
            matchData.value.outSpecialNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.outSpecialSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.outSpecialTaxAmount) || "0.00"
          }元`
          content += `\n\t销项普票：${
            matchData.value.outGeneralNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.outGeneralSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.outGeneralTaxAmount) || "0.00"
          }元\n`
          content += `\n【本${matchData.value.isJd ? "季度" : "月"}取得发票】`
          content += `\n\t进项专票：${
            matchData.value.inSpecialNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.inSpecialSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.inSpecialTaxAmount) || "0.00"
          }元`
          content += `\n\t进项普票：${
            matchData.value.inGeneralNum
          }份|价税合计：${
            proxy.$comdify(matchData.value.inGeneralSumAmount) || "0.00"
          }元\t发票税额：${
            proxy.$comdify(matchData.value.inGeneralTaxAmount) || "0.00"
          }元\n`

          content += `\n季度累计开票金额：${proxy.$comdify(
            taxEstimeInfo.value.out_invoice_in_amount_jd,
          )}元`
          content += `\n连续12个月累计开票金额：${proxy.$comdify(
            taxEstimeInfo.value.out_invoice_in_amount_12,
          )}元`
          // 待定
          content += `\n转为一般纳税人剩余可开票额度：${proxy.$comdify(
            5000000 - taxEstimeInfo.value.out_invoice_in_amount_12,
          )}元\n`
        }
        content += `\n【截止${dayjs().format("YYYY-MM-DD")}】\n`
        // 预勾选之后的
        if (props.comInfo.type == "2" && matchData.value?.countGx) {
          content += `预勾选增值税：${proxy.$comdify(
            taxEstimeInfo.value.estimate_value_added_tax_gx,
          )}\n`
          content += `预勾选附加税：${proxy.$comdify(
            taxEstimeInfo.value.estimate_additional_tax_gx,
          )}\n`
          content += `其中:城市维护建设税：${proxy.$comdify(
            taxEstimeInfo.value.city_construct_tax_gx,
          )}\n`
          content += `     教育费附加税：${proxy.$comdify(
            taxEstimeInfo.value.education_additional_tax_gx,
          )}\n`
          content += `     地方教育费附加税：${proxy.$comdify(
            taxEstimeInfo.value.place_education_additional_tax_gx,
          )}\n`
        } else {
          if (
            taxEstimeInfo.value.out_amount === "0.00" ||
            !taxEstimeInfo.value.out_amount
          ) {
            content +=
              "截止当下预估增值税：" +
              taxEstimeInfo.value.estimate_value_added_tax +
              "元" +
              "(税负0.00%)\n"
          } else {
            content +=
              "截止当下预估增值税：" +
              taxEstimeInfo.value.estimate_value_added_tax +
              "元" +
              "(税负：" +
              (
                (Number(
                  taxEstimeInfo.value.estimate_value_added_tax
                    ? taxEstimeInfo.value.estimate_value_added_tax
                    : 0,
                ) /
                  Number(taxEstimeInfo.value.out_amount)) *
                100
              ).toFixed(2) +
              "%)\n"
          }
          content += `预估附加税：${proxy.$comdify(
            taxEstimeInfo.value.estimate_additional_tax,
          )}\n`
          content += `其中:城市维护建设税：${proxy.$comdify(
            taxEstimeInfo.value.city_construct_tax,
          )}\n`
          content += `     教育费附加税：${proxy.$comdify(
            taxEstimeInfo.value.education_additional_tax,
          )}\n`
          content += `     地方教育费附加税：${proxy.$comdify(
            taxEstimeInfo.value.place_education_additional_tax,
          )}\n`
        }
        content += `\n请注意核实，如有疑问请随时沟通!`
      } else {
        // 企业所得税预估
        content += `预估的累计营收状况如下：\n\n`
        content += `本年累计营业收入：${matchData.value.revenueStr}\n`
        content += `本年累计营业成本：${matchData.value.costStr}\n`
        content += `本年累计期间费用：${matchData.value.expensesStr}\n`
        content += `可抵用进项发票：${matchData.value.inInvoiceAmountStr}\n`
        content += `本年累计利润总额：${matchData.value.totalProfitStr}\n`
        content += `本期预估应缴税款：${matchData.value.taxAmountStr}\n`
        content += `\n如果还有成本、费用发票没有拿到的，辛苦领导尽快催收哦💪\n有不明白的，请联系会计🌹`
      }
      break
  }
  if (method === "shebao") {
    return shebaoContent
  } else {
    return content
  }
}
</script>

<style scoped lang="scss">
.tab_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 5px;
  background-color: #fff;
  font-size: 14px;

  .tab_content_each {
    flex: 1;
    text-align: center;
    padding: 3px 0;
    border: 1px solid #efefef;
    border-radius: 4px;
    cursor: pointer;
  }

  .active {
    color: $color-main;
  }
}

.each_main {
  margin: 0 5px;
  border: 1px solid #efefef;
  padding-top: 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-top: 10px;
  .tab-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 14px;
    padding-bottom: 14px;
  }

  .tabs {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    background-color: #fff;
  }

  .tab {
    width: 140px;
    text-align: center;
    padding-bottom: 8px;
    cursor: pointer;
    position: relative;
  }

  .tab.active {
    color: $color-main;
    border-bottom: 1px solid $color-main;
  }
}

.fw_date {
  margin: 10px 8px 15px;
  font-size: 13px;
}

.send_btn {
  margin: 10px 5px;
  display: flex;
  align-items: center;
  background-color: #fff;
  font-size: 13px;

  & > div {
    flex: 1;
    text-align: center;
    border: 1px solid #efefef;
    padding: 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:first-child {
      color: $color-main;
    }

    &:nth-child(2) {
      color: green;
    }

    &:last-child {
      color: green;
    }
  }
}

.tab_content_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 10px 0;
  color: #17a2b8;
  div:first-of-type {
    color: #2c3e50 !important;
  }
}

.excel_style {
  border: 1px solid #bfbebe;
  padding: 2px 5px 2px 2px;

  .icon-wenjianleixing-biaozhuntu-gongzuobiao {
    font-size: 45px;
    margin-right: 5px;
  }
}

.download_icon {
  color: $color-main;
  cursor: pointer;
}
</style>
